import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { REPORT } from "../config/apiEndPoint";
import { POST } from "config/api.config";

/** POST `Report/backend-performance/filter` */
export const submitBackendPerformanceReportFilterData = async (data = {}) => {
    try {
        const response = await POST(REPORT.BACKEND_PERFORMANCE_FILTER, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
